import { z } from 'zod'

import { emailSchema } from '@/shared/lib/validation/email'

export const bonusConversionFormSchema = z.object({
	NAME: z
		.string({ required_error: 'Введите имя' })
		.min(2, 'Имя должно содержать минимум 2 символа')
		.regex(/^(?!\s*$).+/, 'Имя не может состоять только из пробелов'),
	EMAIL: emailSchema
})

export type BonusConversionFormValues = z.infer<typeof bonusConversionFormSchema>
